"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPatchedVariantSuggestionRequest = instanceOfPatchedVariantSuggestionRequest;
exports.PatchedVariantSuggestionRequestFromJSON = PatchedVariantSuggestionRequestFromJSON;
exports.PatchedVariantSuggestionRequestFromJSONTyped = PatchedVariantSuggestionRequestFromJSONTyped;
exports.PatchedVariantSuggestionRequestToJSON = PatchedVariantSuggestionRequestToJSON;
exports.PatchedVariantSuggestionRequestToJSONTyped = PatchedVariantSuggestionRequestToJSONTyped;
const cardUsedInVariantSuggestionRequest_1 = require("./cardUsedInVariantSuggestionRequest");
const featureProducedInVariantSuggestionRequest_1 = require("./featureProducedInVariantSuggestionRequest");
const templateRequiredInVariantSuggestionRequest_1 = require("./templateRequiredInVariantSuggestionRequest");
/**
 * Check if a given object implements the PatchedVariantSuggestionRequest interface.
 */
function instanceOfPatchedVariantSuggestionRequest(value) {
    return true;
}
function PatchedVariantSuggestionRequestFromJSON(json) {
    return PatchedVariantSuggestionRequestFromJSONTyped(json, false);
}
function PatchedVariantSuggestionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'uses': json['uses'] == null ? undefined : (json['uses'].map(cardUsedInVariantSuggestionRequest_1.CardUsedInVariantSuggestionRequestFromJSON)),
        'requires': json['requires'] == null ? undefined : (json['requires'].map(templateRequiredInVariantSuggestionRequest_1.TemplateRequiredInVariantSuggestionRequestFromJSON)),
        'produces': json['produces'] == null ? undefined : (json['produces'].map(featureProducedInVariantSuggestionRequest_1.FeatureProducedInVariantSuggestionRequestFromJSON)),
        'variantOf': json['variantOf'] == null ? undefined : json['variantOf'],
        'manaNeeded': json['manaNeeded'] == null ? undefined : json['manaNeeded'],
        'easyPrerequisites': json['easyPrerequisites'] == null ? undefined : json['easyPrerequisites'],
        'notablePrerequisites': json['notablePrerequisites'] == null ? undefined : json['notablePrerequisites'],
        'description': json['description'] == null ? undefined : json['description'],
        'spoiler': json['spoiler'] == null ? undefined : json['spoiler'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}
function PatchedVariantSuggestionRequestToJSON(json) {
    return PatchedVariantSuggestionRequestToJSONTyped(json, false);
}
function PatchedVariantSuggestionRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'uses': value['uses'] == null ? undefined : (value['uses'].map(cardUsedInVariantSuggestionRequest_1.CardUsedInVariantSuggestionRequestToJSON)),
        'requires': value['requires'] == null ? undefined : (value['requires'].map(templateRequiredInVariantSuggestionRequest_1.TemplateRequiredInVariantSuggestionRequestToJSON)),
        'produces': value['produces'] == null ? undefined : (value['produces'].map(featureProducedInVariantSuggestionRequest_1.FeatureProducedInVariantSuggestionRequestToJSON)),
        'variantOf': value['variantOf'],
        'manaNeeded': value['manaNeeded'],
        'easyPrerequisites': value['easyPrerequisites'],
        'notablePrerequisites': value['notablePrerequisites'],
        'description': value['description'],
        'spoiler': value['spoiler'],
        'comment': value['comment'],
    };
}
//# sourceMappingURL=patchedVariantSuggestionRequest.js.map